import { useEffect, useState } from "react";
import axios from "axios";
import BASE_URL from "../config";

export default function useStockHistory(symbol, refreshKey = 0) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!symbol) return; // gated: no fetch until a symbol is set
    let cancelled = false;
    setLoading(true);
    axios
      .get(`${BASE_URL}/history/${symbol}`)
      .then((response) => {
        if (cancelled) return;
        const payload = response.data;
        // Backend returns a { error } object (HTTP 200) for invalid tickers.
        if (!Array.isArray(payload)) {
          setData([]);
          setError(`No data for "${symbol}". Check the symbol and try again.`);
        } else {
          setData(payload);
          setError(null);
        }
        setLoading(false);
      })
      .catch((err) => {
        if (cancelled) return;
        console.error(err);
        setError("Couldn't reach the server. Please retry.");
        setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [symbol, refreshKey]);

  return { data, loading, error };
}
